//These prefectures are sorted based on the locations (i.e. from north to south).
//This order is very common in Japan.
//The values are same as ones stored in PostalCodeAddress table in the database
export const PREFECTURES_EN = [
  "HOKKAIDO",
  "AOMORI KEN",
  "IWATE KEN",
  "MIYAGI KEN",
  "AKITA KEN",
  "YAMAGATA KEN",
  "FUKUSHIMA KEN",
  "IBARAKI KEN",
  "TOCHIGI KEN",
  "GUMMA KEN",
  "SAITAMA KEN",
  "CHIBA KEN",
  "TOKYO TO",
  "KANAGAWA KEN",
  "NIIGATA KEN",
  "TOYAMA KEN",
  "ISHIKAWA KEN",
  "FUKUI KEN",
  "YAMANASHI KEN",
  "NAGANO KEN",
  "GIFU KEN",
  "SHIZUOKA KEN",
  "AICHI KEN",
  "MIE KEN",
  "SHIGA KEN",
  "KYOTO FU",
  "OSAKA FU",
  "HYOGO KEN",
  "NARA KEN",
  "WAKAYAMA KEN",
  "TOTTORI KEN",
  "SHIMANE KEN",
  "OKAYAMA KEN",
  "HIROSHIMA KEN",
  "YAMAGUCHI KEN",
  "TOKUSHIMA KEN",
  "KAGAWA KEN",
  "EHIME KEN",
  "KOCHI KEN",
  "FUKUOKA KEN",
  "SAGA KEN",
  "NAGASAKI KEN",
  "KUMAMOTO KEN",
  "OITA KEN",
  "MIYAZAKI KEN",
  "KAGOSHIMA KEN",
  "OKINAWA KEN",
];
